<mat-card class="loading-shade">
  <mat-spinner></mat-spinner>
</mat-card>
